/* eslint-disable class-methods-use-this */
/**
 * Dropdown selection for options
 */
class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.formParent = this.closest('product-form');
      if(this.formParent){
         this.form = this.formParent.querySelector('form') || null;
         this.formType = this.formParent.dataset.format || null;
      }
      this.variant_json = this.querySelector('[data-variantJSON]');
      this.container = this.formType === 'product-card' || this.formType === 'quickview'  ? this.closest('[data-product-card]') : this.closest('[data-product-container]');
    }

    connectedCallback() {
      this.updateSwatchLabel();
      // Track if user has interacted - set true on first change event
      this.userHasInteracted = false;

      // if (this.formType === 'product-page') this.onVariantChange('load');
      let formtemplate = this.formParent?.dataset.template || '';
      if ((this.formType === 'product-page' || this.formType === 'quickview') && formtemplate != 'virtual-race') {
        // Check if product has variants (not only default variant)
        const hasOnlyDefaultVariant = this.closest('.only-default-variant') !== null;
        if (!hasOnlyDefaultVariant) {
          // Wait for the product form to be fully loaded
          this.waitForProductForm(() => {
            // Only initialize if user hasn't already interacted with options
            if (!this.userHasInteracted) {
              this.clearPreselectedVariants();
              this.initializeWithNoSelection();
            }
          });
        }
      }
      this.checkAndUpdateVariantAvailability();
      this.addEventListener('change', (evt) => {
        this.userHasInteracted = true; // Mark that user has interacted
        this.onVariantChange();
      });
    }

    /**
     * Clear any pre-selected variants on page load
     */
    clearPreselectedVariants() {
      const allInputs = this.querySelectorAll('input[type="radio"]');
      allInputs.forEach(input => {
        input.checked = false;
      });
    }

    /**
     * Initialize the product page with no variant selected
     */
    initializeWithNoSelection() {
      // Set placeholder text for all option labels
      const optionLabels = this.querySelectorAll('.selected-option');
      optionLabels.forEach(label => {
        const placeholder = label.dataset.placeholder || 'Please select';
        label.textContent = placeholder;
        label.classList.add('placeholder-text');
      });
      
      // Disable the add to cart button with "Select All Options" message
      if (this.formParent && typeof this.formParent.toggleAddButton === 'function') {
        this.formParent.toggleAddButton('disable', false, true); // needsSelection = true
      }
      
      // Disable the personalize button too
      if (this.formParent && typeof this.formParent.togglePersonalizeButton === 'function') {
        this.formParent.togglePersonalizeButton(false,this.formParent);
      }
    }

    updateSwatchLabel(){
      const colorSwatchContainer = this.querySelector('.color-swatch');
      
      
      if(colorSwatchContainer){
        const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
        colorSwatches.forEach(swatch => {
          const colorHandle = swatch.querySelector('input[type="radio"]').dataset.handle;
          const swatchStyle = Utility.getSwatchStyle(colorHandle);
          swatch.querySelector('.swatch-label').setAttribute('style', swatchStyle);
        });
      }
    }

    waitForProductForm(callback) {
      const checkForm = () => {
        if (this.formParent && typeof this.formParent.updateProductDetails === 'function') {
          callback();
        } else {
          setTimeout(checkForm, 50);
        }
      };
      checkForm();
    }
  
    /**
     * Trigger this function when variant is changed
     */
    onVariantChange() {
      this.setCurrentVariant();
      const allOptionsSelected = this.validateAllOptionsSelected();

      eventBus.publish(PUB_SUB_EVENTS.variantChange, {
        data: {
          container: this.container,
          variant: this.currentVariant,
        },
      });

      this.updateOptionLabel(this.container);
      this.checkAndUpdateVariantAvailability();

      if (this.dataset.selectedid && this.currentVariant) {
        this.dataset.selectedid = this.currentVariant.id;
      }

      document.dispatchEvent(
        new CustomEvent('Option:VariantChange', {
          detail: { variant: this.currentVariant, element: this },
          bubbles: true,
          cancelable: false
        })
      );

      if (!this.formType) return;

      if (this.formType === 'product-card') {
        this.updateProductCardImage();
      }

      if (this.formType === 'quickview') {
        let variantForUpdate = this.currentVariant || this.findPartialVariant();

        if (variantForUpdate) {
          document.dispatchEvent(
            new CustomEvent('Quickview:VariantChange', {
              detail: { variant: variantForUpdate, formElement: this.formParent },
              bubbles: true,
              cancelable: false
            })
          );
        }

        if (typeof this.formParent?.updateProductDetails === 'function') {
          this.formParent.updateProductDetails(this.container, variantForUpdate, !allOptionsSelected);
        }

        if (this.currentVariant && this.currentVariant.sku) {
          let sku_element = this.container.querySelectorAll('[data-event-variant-sku]');
          if (sku_element.length) {
            sku_element.forEach(el => el.innerText = this.currentVariant.sku);
          }
        }

        return;
      }

      if (this.formType === 'product-page' && window.globalSpace.templateSuffix !== 'virtual-race') {
        let variantForUpdate = this.currentVariant || this.findPartialVariant();

        if (typeof this.formParent?.updateProductDetails === 'function') {
          this.formParent.updateProductDetails(this.container, variantForUpdate, !allOptionsSelected);
        }

        if (!this.currentVariant && !allOptionsSelected) {
          return;
        }

        if (!this.currentVariant && window.globalSpace.product) {
          this.currentVariant = window.globalSpace.product.variants[0];
        }

        window.globalSpace.product.currentVariant = this.currentVariant;
      }

      if (this.formType === 'product-page') {
        let sku_element = this.container.querySelectorAll('[data-event-variant-sku]');
        if (sku_element.length && this.currentVariant && this.currentVariant.sku) {
          sku_element.forEach(el => el.innerText = this.currentVariant.sku);
        }

        if (this.currentVariant && typeof this.formParent?.updateProductDetails === 'function') {
          this.formParent.updateProductDetails(this.container, this.currentVariant);
        }
      }

      if (
        this.formType !== 'product-page' &&
        this.formType !== 'quickview' &&
        typeof this.formParent?.updateProductDetails === 'function'
      ) {
        this.formParent.updateProductDetails(this.container, this.currentVariant);
      }
    }

    /**
     * Validate that all required options are selected
     */
    validateAllOptionsSelected() {
      const optionContainers = this.querySelectorAll('fieldset, .product-form__input--dropdown');
      let allSelected = true;
      
      optionContainers.forEach(container => {
        const checkedInput = container.querySelector('input[type="radio"]:checked');
        if (!checkedInput) {
          allSelected = false;
        }
      });
      
      return allSelected;
    }

    /**
     * Find a variant that matches the currently selected options (even if incomplete)
     * Used for updating images when only color is selected
     */
    findPartialVariant() {
      const selectedOptions = this.selectedOptionValues;
      const variants = this._getVariantData();
      
      // Filter variants that match the selected options
      const matchingVariants = variants.filter(variant => {
        return selectedOptions.every((selectedOption, index) => {
          // If no option selected at this index, skip the check
          if (!selectedOption || selectedOption === '') return true;
          // Check if variant matches the selected option
          return variant.options[index] === selectedOption;
        });
      });
      
      // Prioritize available variants, but return any match if none available
      const availableMatch = matchingVariants.find(v => v.available);
      return availableMatch || matchingVariants[0];
    }

    updateProductCardImage() {
      // For product-card only - quickview is handled separately in onVariantChange
      if (!this.currentVariant) return;
      if (this.formType !== 'product-card') return;
      if (!this.currentVariant?.featured_media) return;
      
      if(!this.container){
        this.container = this.closest('[data-product-card]');
      }
      const variantId = this.currentVariant.id.toString();
      const query = `
            query MyQuery {
              node(id: "gid://shopify/ProductVariant/${variantId}") {
                ... on ProductVariant {
                      id
                      title
                      metafield(namespace: "custom", key: "variant_media") {
                        id
                        references(first: 3) {
                          edges {
                            node {
                              ... on MediaImage {
                                id
                                image {
                                  url
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              `;
        fetch(`${window.globalSpace.apiDomain}/api/2023-01/graphql.json`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": "382d0c774e95be1f0d7c90e6c08bba49"
          },
          body: JSON.stringify({ query })
        })
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then(res => {
          const variantData = res?.data?.node;
          const edges = variantData?.metafield?.references?.edges || [];
          const images = edges.map(edge => edge?.node?.image?.url).filter(Boolean);
          const variantTitle = variantData?.title || this.currentVariant.title;
          const productImageWrapper = this.container.querySelector('.product-images-wrapper');
          const mainImage = productImageWrapper?.querySelector('.main-image');
          const secondaryImage = productImageWrapper?.querySelector('.secondary-image');
          // Function to generate responsive srcset for variant images
          const generateResponsiveSrcset = (imageUrl, sizes = [350, 500]) => {
            if (!imageUrl) return '';
            const cleanUrl = imageUrl.split('?')[0]; // Remove old params
            return sizes.map(size => `${cleanUrl}?width=${size} ${size}w`).join(', ');
          };
        
          // Update main image
          if (mainImage && images[0]) {
            const mainImageUrl = images[0];
            mainImage.src = `${mainImageUrl}?width=400`;
            mainImage.srcset = generateResponsiveSrcset(mainImageUrl, [350, 500]);
            mainImage.alt = variantTitle;
            mainImage.setAttribute('data-variant-title', variantTitle);
            mainImage.setAttribute('loading', 'lazy');
          }
        
          // Update secondary image
          if (secondaryImage) {
            const secondaryImageUrl = images[1] || images[0]; // fallback to main image
            secondaryImage.src = `${secondaryImageUrl}?width=400`;
            secondaryImage.srcset = generateResponsiveSrcset(secondaryImageUrl, [300, 500]);
            secondaryImage.alt = variantTitle;
            secondaryImage.setAttribute('loading', 'lazy');
          }
        })
        .catch(error => {
          console.error("Error fetching variant metafields:", error);
        });
    }

    checkAndUpdateVariantAvailability() {
      const optionContainers = Array.from(this.querySelectorAll('fieldset, .product-form__input--dropdown'));
      if (optionContainers.length >= 2) {
        this.updateVariantAvailability();
      }
    }

    updateVariantAvailability() {
      const variants = this._getVariantData();
      if (!variants) return;
      const selectedOptions = this.selectedOptionValues;
      if (!selectedOptions) return;

      const optionContainers = Array.from(this.querySelectorAll('fieldset, .product-form__input--dropdown'));
      // Update availability for all options based on current selections
      optionContainers.forEach((container, optionIndex) => {
        const radioInputs = container.querySelectorAll('input[type="radio"]');
        if (radioInputs.length > 0) {
          this.updateRadioInputsAvailability(radioInputs, variants, selectedOptions, optionIndex);
        }

        const dropdownContainer = container.querySelector('.toggle-content-wrap');
        if (dropdownContainer) {
          const dropdownInputs = dropdownContainer.querySelectorAll('input.variant_selector');
          this.updateDropdownInputsAvailability(dropdownInputs, variants, selectedOptions, optionIndex);
        }
      });
    }

    updateRadioInputsAvailability(inputs, variants, selectedOptions, currentOptionIndex) {
      inputs.forEach(input => {
        const optionValue = input.value;
        const { exists, isAvailable } = this.checkVariantAvailability(variants, selectedOptions, currentOptionIndex, optionValue);
        const swatchLi = input.closest('li');
        this.updateOptionVisibility(input, swatchLi, exists, isAvailable, currentOptionIndex);
      });
      this.handleAutoSelection(inputs);
    }

    updateDropdownInputsAvailability(inputs, variants, selectedOptions, currentOptionIndex) {
      inputs.forEach(input => {
        const optionValue = input.value;
        const { exists, isAvailable } = this.checkVariantAvailability(variants, selectedOptions, currentOptionIndex, optionValue);
        const menuItem = input.closest('li');
        this.updateOptionVisibility(input, menuItem, exists, isAvailable, currentOptionIndex);
      });
    }

    // Helper method to check variant availability
    checkVariantAvailability(variants, selectedOptions, currentOptionIndex, optionValue) {
      const exists = variants.some(variant => {
        return variant.options[currentOptionIndex] === optionValue && this.matchesOtherSelectedOptions(variant, selectedOptions, currentOptionIndex);
      });
      const isAvailable = variants.some(variant => {
        return variant.available && variant.options[currentOptionIndex] === optionValue && this.matchesOtherSelectedOptions(variant, selectedOptions, currentOptionIndex);
      });
      return { exists, isAvailable };
    }

    // Helper method to update option visibility and disabled state
    updateOptionVisibility(input, container, exists, isAvailable, optionIndex) {
      const isColorOption = optionIndex === 0;
      if (isColorOption) {
        // Always show color options
        if (container) container.style.display = '';
        this.updateDisabledState(input, isAvailable);
      } else {
        // For other options, hide if they don't exist
        if (exists) {
          if (container) container.style.display = '';
          this.updateDisabledState(input, isAvailable);
        } else {
          if (container) container.style.display = 'none';
        }
      }
    }

    // Helper method to update disabled state
    updateDisabledState(input, isAvailable) {
      if (isAvailable) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    }

    // Helper method to handle auto-selection
    handleAutoSelection(inputs) {
      // DISABLED: We don't want auto-selection anymore
      // Users must manually select all options
      return;
    }

    // Helper method to check if a variant matches all other selected options
    matchesOtherSelectedOptions(variant, selectedOptions, currentOptionIndex) {
      return selectedOptions.every((selectedOption, index) => {
        // Skip the current option index since we're checking that separately
        if (index === currentOptionIndex) return true;
        // If no option is selected for this index, consider it a match (show all possibilities)
        if (!selectedOption || selectedOption === '') return true;
        return variant.options[index] === selectedOption;
      });
    }

    get selectedOptionValues() {
      // Build array that maps to option indices correctly
      const optionContainers = Array.from(this.querySelectorAll('fieldset, .product-form__input--dropdown'));
      return optionContainers.map(container => {
        const checkedInput = container.querySelector('input[type="radio"]:checked');
        return checkedInput ? checkedInput.value : '';
      });
    }

    /**
     * change value of currentVariant when variant being changed 
     */
    setCurrentVariant() {
      this.currentVariant = false;
      const options = this.selectedOptionValues;
      const variants = this._getVariantData();
      variants.find(variant => {
          if (variant.options.every((option, i) => options[i] === option)) {
            this.currentVariant = variant;
          }
      });
      // REMOVED: Don't auto-select first variant - require user selection
      // if (!this.currentVariant && variants.length > 0) {
      //   this.currentVariant = variants[0];
      // }
    }
  
    /**
     * Update selected option name label
     */
    updateOptionLabel(form) {
      if (!form) return;
      const metafieldMap = {};
      const metafieldString = this.dataset.metafieldMap || '';
      if (metafieldString) {
        metafieldString.split(',').forEach(pair => {
          const [key, value] = pair.split(':');
          if (key && value) {
            metafieldMap[key.trim()] = value.trim();
          }
        });
      }
      const optionGroups = form.querySelectorAll('[data-optionindex]');
      optionGroups.forEach(option => {
        const label = option.querySelector('.selected-option');
        const checkedInput = option.querySelector('input:checked');
        if (label && checkedInput) {
          const optionValue = checkedInput.value;
          const mappedValue = metafieldMap[optionValue] || optionValue;
          const optionType = label.dataset.optionType?.toLowerCase();
          // Remove placeholder styling when option is selected
          label.classList.remove('placeholder-text');
          // If we have a mapping and the value exists in it, use the mapped value
          if (Object.keys(metafieldMap).length > 0 && metafieldMap[optionValue]) {
            label.textContent = metafieldMap[optionValue];
          } else {
            // Otherwise, use the default formatting
            if (optionType === 'color') {
              label.textContent = optionValue.toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
            } else if (optionType === 'size') {
              label.textContent = optionValue.toUpperCase();
            } else {
              label.textContent = optionValue;
            }
          }
        } else if (label && !checkedInput) {
          // No option selected - show placeholder
          const placeholder = label.dataset.placeholder || 'Please select';
          label.textContent = placeholder;
          label.classList.add('placeholder-text');
        }
      
      });
    }

    /**
     * Store the all the variants json
     */
    _getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
      return this.variantData;
    }

    getInputForEventTarget(target) {
      return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
    }

    get optionValues() {
      return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
        ({ dataset }) => dataset.optionValueId
      );
    }
}
customElements.define('variant-selects', VariantSelects);